export default __webpack_public_path__ + "static/media/corporativa.87b0f5af.png";